import React, { Component } from 'react'
import { Link, withRouter } from "react-router-dom"
import { Container, Row, Col, Button, Card, Navbar, Nav, NavDropdown, Image, Table } from 'react-bootstrap'
import ErrorExamAnalysisHOme from '../components/exams/error_exam_analysis/ErrorExamAnalysisHome';


import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from 'lodash.flowright';
import { STUDENT_GLOBALS } from "../../utils/studentGlobals";
import PreloaderTwo from '../components/preloader/PreloaderTwo'
import BrandLogo from '../components/navbars/BrandLogo'
import CommonHeader from '../components/navbars/CommonHeader';



const FETCH_SESSION_DATA = gql`
  query(
          $student_user_exam_id: Int!, $exam_session_id: ID) {
            getStudentExamSessions(student_user_exam_id: $student_user_exam_id, exam_session_id: $exam_session_id){
                in_time
                less_time
                over_time
                total_questions
              subject_report{
                id
                subject
                in_time
                less_time
                over_time
                totalSubjectWiseMarks
               }

              result_questions{
                id
                subject
                status
                reason_for_wrong
                comments
              }
          }
      }
`;






// Inline shimmer skeleton (stat cards + chart + table) shown while loading.
const ExamWiseErrorAnalysisShimmer = () => (
    <div className="py-4">
        <div className="rz-shimmer rz-skel-title" style={{ width: '35%', height: '24px' }} />
        <div className="row mt-3">
            {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="col-xl-3 col-lg-3 col-md-6 col-12 mb-4">
                    <div className="rz-skel-card border-0 text-center">
                        <div className="rz-shimmer rz-skel-circle mx-auto mb-3" style={{ width: '48px', height: '48px' }} />
                        <div className="rz-shimmer rz-skel-line mx-auto" style={{ width: '60%' }} />
                        <div className="rz-shimmer rz-skel-line sm mx-auto mb-0" style={{ width: '40%' }} />
                    </div>
                </div>
            ))}
        </div>
        <div className="rz-skel-card border-0 mb-4">
            <div className="rz-shimmer rz-skel-line" style={{ width: '25%' }} />
            <div className="rz-shimmer" style={{ width: '100%', height: '260px', borderRadius: '10px' }} />
        </div>
        <div className="rz-skel-card border-0">
            {Array.from({ length: 5 }).map((_, i) => (<div key={i} className="rz-shimmer rz-skel-line" style={{ width: '100%' }} />))}
        </div>
    </div>
);

class ExamWiseErrorAnalysis extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }


    render() {

        if (Cookies.get("studenttoken") == undefined)
            this.props.history.push("/student/login");
        const getStudentExamSessions = this.props.getStudentExamSessions;
        const loading1 = getStudentExamSessions.loading;
        const error1 = getStudentExamSessions.error;
        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        const studentGlobals = this.props.studentGlobals;
        const loading2 = studentGlobals.loading;
        const error2 = studentGlobals.error;
        if (error2 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }

        return (
            <div className='practice_exams_area'>
                <CommonHeader color="auto" tone="light" back={true} title="Error Analysis" left={<BrandLogo fill="#ffffff" />} />
                <Container>
                    <Row className="align-items-center my-3">
                        <Col className="d-flex justify-content-between align-center">
                            <div className="title-block">
                                <h5 className="title mb-0">Error Analysis</h5>
                            </div>
                            <div className="right-content d-flex align-items-center">
                                <button className="d-flex align-items-center rounded-pill btn px-3 py-2 ml-2" style={{ background: '#212b64', color: '#fff', border: '1px solid #212b64' }} onClick={this.props.history.goBack} > Back</button>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Container>
                    {(loading1 == true || loading2 == true) && (<ExamWiseErrorAnalysisShimmer />)}
                    {
                        !loading1 && !loading2 && (
                            <ErrorExamAnalysisHOme getStudentExamSessions={getStudentExamSessions.getStudentExamSessions} studentGlobals={studentGlobals.studentGlobals} />
                        )
                    }
                </Container>
            </div>
        )
    }
};


export default
    withRouter(
        compose(graphql(FETCH_SESSION_DATA,
            {
                options: props => ({
                    variables: {
                        student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")),
                        exam_session_id: parseInt((props.history.location.state || {}).sessionid),

                    },
                    fetchPolicy: "network-only"
                }), name: "getStudentExamSessions"
            }), graphql(STUDENT_GLOBALS,
                {
                    options: props => ({
                        variables: {
                            student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")),
                        }
                        ,
                        // Shared studentGlobals union; see utils/studentGlobals.
                        fetchPolicy: "cache-first"
                    }), name: "studentGlobals"
                }),

        )(ExamWiseErrorAnalysis));
